<template>
  <i class="n-icon" >
      <svg class="icon" :class="{ fill: isFill }" aria-hidden="true" :style="{color:color}"
      @click.stop="handleClick">
        <use :xlink:href="'#' + icon"></use>
      </svg>
      <span class="slot" v-if="$slots.default"><slot></slot></span>
  </i>
</template>

<script>
export default {
  props: {
    fill: {
      default: false,
      type: Boolean,
    },
    icon: {
      type: String,
      default: "",
    },
    color: {
      type: String,
  
    },
  },
  data() {
    return {
      isFill: this.fill
    };
  },
  watch: {
    fill(val) {
      this.isFill = val
    },
  },
  methods: {
    handleClick() {
      // this.isFill = !this.isFill;
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.n-icon {
  user-select: none;
  text-decoration: none;
  font-style: normal;
  cursor: pointer;
  vertical-align: middle;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  &:hover .icon {
    transition: all 0.2s ease;
    color: #fa9075;
  }
  span {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
  svg,
  img {
    width: 24px;
    height: 24px;
    vertical-align: middle;
  }
}
.icon {
  cursor: pointer;
}
.fill {
  fill: #ec7a5d;
}
.slot {
  margin-left: 10px;
}
</style>
